import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CustomerViewLayer from "../components/CustomerViewLayer";
import "../styles/orders.css"

const CustomerViewPage = () => {

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Customer' />

        {/* BlogLayer */}
        <CustomerViewLayer />
      </MasterLayout>
    </>
  );
};

export default CustomerViewPage;
